import { render } from "./medicalIcons.vue?vue&type=template&id=6ad8c7e6&scoped=true"
import script from "./medicalIcons.vue?vue&type=script&lang=js"
export * from "./medicalIcons.vue?vue&type=script&lang=js"

import "./medicalIcons.vue?vue&type=style&index=0&id=6ad8c7e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad8c7e6"]])

export default __exports__